import { z } from 'zod';

export const schemaConsorsSubscriptionIdentifierExternal = z
    .string()
    .min(0)
    .max(21)
    .regex(/^[a-zA-Z0-9ßäöüÖÄÜ .,&+/-]*$/, 'Invalid characters');
